const actions = {
  VOICE_DEVICE_REGISTER: "VOICE_DEVICE_REGISTER",
  VOICE_DEVICE_REGISTERED: "VOICE_DEVICE_REGISTERED",
  VOICE_DEVICE_REGISTERING: "VOICE_DEVICE_REGISTERING",
  VOICE_DEVICE_UNREGISTERED: "VOICE_DEVICE_UNREGISTERED",
  VOICE_DEVICE_INCOMING: "VOICE_DEVICE_INCOMING",
  VOICE_CALL_INCOMING: "VOICE_CALL_INCOMING",
  VOICE_CALL_INCOMING_ACCEPTED: "VOICE_CALL_INCOMING_ACCEPTED",
  VOICE_DEVICE_ERROR: "VOICE_DEVICE_ERROR",
  VOICE_CALL_ACCEPT: "VOICE_CALL_ACCEPT",
  VOICE_CALL_ACCEPTED: "VOICE_CALL_ACCEPTED",
  VOICE_CALL_CANCELLED: "VOICE_CALL_CANCELLED",
  VOICE_CALL_IGNORED: "VOICE_CALL_IGNORED",
  VOICE_CALL_TOGGLE_MUTED: "VOICE_CALL_TOGGLE_MUTED",
  VOICE_CALL_MUTED: "VOICE_CALL_MUTED",
  VOICE_CALL_REJECTED: "VOICE_CALL_REJECTED",
  VOICE_CALL_RINGING: "VOICE_CALL_RINGING",
  VOICE_CALL_CONNECTING: "VOICE_CALL_CONNECTING",
  VOICE_CALL_CONNECT: "VOICE_CALL_CONNECT",
  VOICE_CALL_CONNECTED: "VOICE_CALL_CONNECTED",
  VOICE_CALL_DISCONNECT_ALL: "VOICE_CALL_DISCONNECT_ALL",
  VOICE_CALL_DISCONNECTING: "VOICE_CALL_DISCONNECTING",
  VOICE_CALL_DISCONNECTED: "VOICE_CALL_DISCONNECTED",
  VOICE_CALL_RECONNECTING: "VOICE_CALL_RECONNECTING",
  VOICE_CALL_RECONNECTED: "VOICE_CALL_RECONNECTED",
  VOICE_CALL_REJECT: "VOICE_CALL_REJECT",
  VOICE_CALL_DISCONNECT: "VOICE_CALL_DISCONNECT",
  // VOICE_CALL_CONNECT_EVENT_CHANGE: "VOICE_CALL_CONNECT_EVENT_CHANGE",
  // VOICE_CALL_DEVICE_EVENT_CHANGE: "VOICE_CALL_DEVICE_EVENT_CHANGE",
  VOICE_CALL_TOGGLE_RECORD: "VOICE_CALL_TOGGLE_RECORD",
  VOICE_CALL_WARNING: "VOICE_CALL_WARNING",
  VOICE_CALL_WARNING_CLEARED: "VOICE_CALL_WARNING_CLEARED",
  VOICE_CALL_ERROR: "VOICE_CALL_ERROR",
  VOICE_CALL_CLOSED: "VOICE_CALL_CLOSED",
  VOICE_CALL_CLEARED: "VOICE_CALL_CLEARED",
  CLEAR_VOICE_CALL_ERROR: "CLEAR_VOICE_CALL_ERROR",
  VOICE_DEVICE_TOKEN_WILL_EXPIRE: "VOICE_DEVICE_TOKEN_WILL_EXPIRE",
  register: () => {
    // console.log("voiceActions.register")
    return (dispatch) => {
      dispatch({
        type: actions.VOICE_DEVICE_REGISTER,
      });
    };
  },
  acceptCall: (callSid) => {
    return (dispatch) => {
      // console.log("voiceActions.acceptCall", callSid);
      dispatch({
        type: actions.VOICE_CALL_ACCEPT,
        callSid,
      });
    };
  },
  connectCall: (params, memberInfo) => {
    return (dispatch, getState) => {
      if (getState().Voice.activeCalls?.length) {
        return;
      }
      dispatch({
        type: actions.VOICE_CALL_CONNECT,
        params: {
          ...params,
          options: {
            Record: getState().Voice.record,
          },
        },
        memberInfo,
      });
    };
  },
  disconnectCall: (callSid) => {
    return (dispatch, getState) => {
      const voiceCall = getState().Voice[callSid];
      voiceCall.direction === 'INCOMING' && voiceCall.status !== "open" ?
        dispatch({
          type: actions.VOICE_CALL_REJECT,
          callSid,
        }) :
        dispatch({
          type: actions.VOICE_CALL_DISCONNECT,
          callSid,
        })
    };
  },
  disconnectAll: (params) => {
    return (dispatch) => {
      dispatch({
        type: actions.VOICE_CALL_DISCONNECT_ALL,
        params,
      });
    };
  },
  toggleMute: () => {
    return (dispatch) => {
      dispatch({
        type: actions.VOICE_CALL_TOGGLE_MUTED,
      });
    };
  },
  clearCallError: () => {
    return (dispatch) => {
      dispatch({
        type: actions.CLEAR_VOICE_CALL_ERROR,
      });
    };
  },
  toggleRecord: () => {
    return (dispatch) => {
      dispatch({
        type: actions.VOICE_CALL_TOGGLE_RECORD,
      });
    };
  }
};

export default actions;
